import React from "react";

interface Category {
  category_count: number,
  id: number,
  image: string,
  name: string,
  priority: number,
  slug: string,
  type: number
}
interface IProps {
  categories: Category[],
  activeCategory: number,
  updateCategory: (category_id: number, hotGame: number, newGame: number) => void
  setCategoryType: (categoryType: number) => void,
  hotGames: number,
  newGames: number,
}

const Categories: React.FC<IProps> = ({ categories, activeCategory, updateCategory, setCategoryType, hotGames, newGames }) => {
  const onChangeSelect = (value: string) => {
    if (value === "hot") {
      updateCategory(-1, 1, 0)
    } else if (value === "new") {
      updateCategory(-1, 0, 1)
    } else {
      updateCategory(Number.parseInt(value), 0, 0);

    }
  };

  return (
    <>
      {categories && (

        <select onChange={(e) => { onChangeSelect(e.target.value) }} name="categories">
          <option value="-2">Lobby</option>
          <option value="hot">Hot Games</option>
          <option value="new">New Games</option>
          <option value="-1">All Games</option>

          {categories.map((category) => {
            return (<option value={category.id} key={category.id}>{category.name}</option>)
          })}
        </select>
      )}

      <div className="categories">
        <div className={(activeCategory === -2) ? "category active" : "category"} onClick={() => { updateCategory(-2, 0, 0) }}><div><i className={`icon icon-lobby`}></i><span>Lobby</span></div></div>

        <div className={(hotGames) ? "category active" : "category"} onClick={() => { updateCategory(-1, 1, 0) }}><div><i className={`icon icon-hot`}></i><span>Hot Games</span></div></div>
        <div className={(newGames) ? "category active" : "category"} onClick={() => { updateCategory(-1, 0, 1) }}><div><i className={`icon icon-new`}></i><span>New Games</span></div></div>

        {categories.map(category => {
          return (
            <div className={(activeCategory === category.id) ? "category active" : "category"} key={category.id}>
              <div onClick={() => { updateCategory(category.id, 0, 0); setCategoryType(category.type) }} >
                <i className={`icon icon-${category.slug}`}></i><span>{category.name}</span>
              </div>
            </div>
          )
        })}
        <div className={(activeCategory === -1 && !(hotGames === 1 || newGames === 1)) ? "category active" : "category"} onClick={() => { updateCategory(-1, 0, 0) }}><div><i className={`icon icon-all`}></i><span>All Games</span></div></div>

      </div>
    </>
  );
}

export default Categories;